import React from "react";
import { cn } from "~/lib/cn";
import { safeBuilderText } from "~/lib/builder-utils";

interface HeadingProps {
  preHeadline?: unknown;
  headline?: unknown;
  subheadline?: unknown;
  className?: string;
  isH1?: boolean;
}

interface HeadingElementProps {
  isH1?: boolean;
  className?: string;
  children: React.ReactNode;
}

export const HeadingElement = ({
  isH1,
  className,
  children,
  ...props
}: HeadingElementProps) => {
  if (isH1) {
    return (
      <h1 className={className} {...props}>
        {children}
      </h1>
    );
  }
  return (
    <h2 className={className} {...props}>
      {children}
    </h2>
  );
};

export const Heading = ({
  preHeadline,
  headline,
  subheadline,
  className,
  isH1,
}: HeadingProps) => {
  const safePreHeadline = safeBuilderText(preHeadline);
  const safeHeadline = safeBuilderText(headline);
  const safeSubheadline = safeBuilderText(subheadline);

  return (
    <div className={cn(className, "text-center")}>
      {safePreHeadline && (
        <p className="mb-4 text-sm font-medium uppercase tracking-wide text-purple-700">
          {safePreHeadline}
        </p>
      )}
      {safeHeadline && (
        <HeadingElement
          isH1={isH1}
          className="font-heading mx-auto mb-4 max-w-2xl text-3xl font-medium tracking-tight sm:text-4xl md:text-5xl"
        >
          {safeHeadline}
        </HeadingElement>
      )}
      {safeSubheadline && (
        <p className="text-muted-foreground mx-auto mb-8 max-w-xl text-xl">
          {safeSubheadline}
        </p>
      )}
    </div>
  );
};

export default Heading;
